export const COMPLIANCE_TYPES: Object = {
  ALL_OPEN_CERTS: 'allOpenCerts',
  NEEDS_REVIEW: 'needsReview',
};
